import { Component, inject, Input, OnInit } from '@angular/core';
import { AbstractControl, FormArray, FormBuilder, FormGroup } from '@angular/forms';
import { DateType } from 'projects/alden-extension/src/lib/models/date-types';
import { MatDialog } from '@angular/material/dialog';
import { UdeuLoan } from 'projects/deusto-extension/src/lib/model/classes/udeu-loan';
import { KeyValue } from '@angular/common';
import { CreateLoanDialogComponent } from '../../../loans/create-loan/create-loan.dialog';
import { LoanActionTypes } from 'projects/deusto-extension/src/lib/store/actions/loan-actions';
import { UDEU_LOAN_BORROWED_STATUS, UDEU_LOAN_FINISHED_STATUS, UDEU_LOAN_IN_PROGRESS_STATUS, UDEU_LOAN_RETURNED_STATUS } from 'projects/deusto-extension/src/lib/model/contants/deusto';
import { AppStore, SnackbarErrorAction } from '@alfresco/aca-shared/store';
import { Store } from '@ngrx/store';
import { UdeuRecord } from 'projects/deusto-extension/src/lib/model/classes/udeu-record';
import { LoanService } from 'projects/deusto-extension/src/lib/services/loan.service';
import { TranslationService } from '@alfresco/adf-core';
import { ReloadCustomListTableAction } from 'projects/alden-extension/src/lib/store/actions/alden.actions';
import { SMTConfirmDialogComponent } from 'projects/alden-extension/src/lib/dialogs/confirm/confirm.dialog';
import { MIMETYPES } from 'projects/alden-extension/src/lib/models/mime-types';

@Component({
  selector: 'alden-loans',
  templateUrl: './loans.component.html',
  styleUrls: ['./loans.component.scss'],
})
export class LoansRegisterComponent implements OnInit {
  @Input() record: UdeuRecord;
  @Input() group: FormGroup<any>;
  @Input() controlName: string;
  @Input() isManager: boolean;
  @Input() history: boolean = false;

  private _formBuilder = inject(FormBuilder);

  DateType: typeof DateType = DateType;
  disabled: boolean;
  UDEU_LOAN_BORROWED_STATUS = UDEU_LOAN_BORROWED_STATUS;
  UDEU_LOAN_IN_PROGRESS_STATUS = UDEU_LOAN_IN_PROGRESS_STATUS;

  loading: boolean;

  constructor(public dialog: MatDialog, protected store: Store<AppStore>, private loanService: LoanService, private translationService: TranslationService) { }
  
  ngOnInit(): void {
    this.loading = true;
    this.disabled = this.group?.get(this.controlName).disabled || this.history;

    const loans = this.record.loans;
    if (loans) {
      loans.forEach((loan) => {
        const loanStatus = (loan.status.status as KeyValue<string, string>).key;
        // Comprobar si es historico o no
        if(!this.history && (loanStatus === UDEU_LOAN_BORROWED_STATUS || loanStatus === UDEU_LOAN_IN_PROGRESS_STATUS) 
          || this.history && (loanStatus === UDEU_LOAN_FINISHED_STATUS || loanStatus === UDEU_LOAN_RETURNED_STATUS)) {
          const form = this.createForm(loan);
          this.formArray.push(form);
        }
      });
    }

    this.loading = false;
  }

  createForm(loan?: UdeuLoan): FormGroup<any> {
    return this._formBuilder.group({
      id: [{ value: loan?.id, disabled: true }],
      name: [{ value: loan?.name, disabled: true }],
      status: [{ value: (loan?.status?.status as KeyValue<string,string>), disabled: true }],
      applicantName: [{ value: loan?.data?.applicantName, disabled: true }],
      email: [{ value: loan?.data?.email, disabled: true }],
      requestDate: [{ value: loan?.data?.requestDate, disabled: true }],
      reason: [{ value: loan?.data?.reason, disabled: true }],
      lastYearEnrollment: [{ value: loan?.data?.lastYearEnrollment, disabled: true }],
      student: [{ value: loan?.data?.student, disabled: true }],
      description: [{ value: loan?.data?.description, disabled: true }],
      startDate: [{ value: loan?.info?.startDate, disabled: true }],
      endDate: [{ value: loan?.info?.endDate, disabled: true }],
    });
  }

  get formArray(): FormArray {
    return this.group.get(this.controlName) as FormArray;
  }

  formArrayGroup (index: number): FormGroup {
    return this.formArray.at(index) as FormGroup;
  }

  viewLoan(id: string) {
    this.dialog.open(CreateLoanDialogComponent,
      {
        disableClose: true,
        autoFocus: true,
        width: '80%',
        maxHeight: '90%', 
        data:  { UUID: id, loanActionType: LoanActionTypes.ViewLoan }
      },
    );
  }

  revokeLoanRecord(control: AbstractControl<any, any>, index: number) {
    const loanId = control.get('id').value;
    const loanName = control.get('name').value;
    const dialogRef = this.dialog.open(SMTConfirmDialogComponent, {
      data: { 
        title: 'DEUSTO.DIALOGS.REVOKE_LOAN.TITLE',
        htmlContent: this.translationService.instant('DEUSTO.DIALOGS.REVOKE_LOAN.MESSAGE', { regName: this.record.name, loanName: loanName }),
        noLabel: 'DEUSTO.DIALOGS.REVOKE_LOAN.NO_LABEL',
        yesLabel: 'DEUSTO.DIALOGS.REVOKE_LOAN.YES_LABEL',
      },
      minWidth: '250px'
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.loading = true;
        this.loanService.asssignRecord(loanId, [this.record.id], true).then(() => {
          const formArray = this.formArray;
          formArray.removeAt(index);
          this.store.dispatch(new ReloadCustomListTableAction(false));
          this.loading = false;
        });
      }
    });
  }

  
  async printReceipt(loanId: string, loanName: string) {
    this.loading = true;

    await this.loanService.getReceipt(loanId, this.record.id).then((res) => {
      const filename = loanName + "_Testigo" + MIMETYPES[res.type.split(';')[0]].extension;
      
      const file = new File([res], filename);
      const url= window.URL.createObjectURL(file);
      
      var linkToFile = document.createElement('a');
      linkToFile.download = filename;
      linkToFile.href = url;
      linkToFile.click();
    }).catch((err) => {
      console.error("ERROR", err);
      this.store.dispatch(new SnackbarErrorAction('ALDEN.MESSAGES.ERRORS.RESPONSE.500'));
    });

    this.loading = false;
  }

}
